import { BarChart3, type LucideIcon, Megaphone, Settings, Wrench } from "lucide-react"

export interface WorkspaceNavItem {
	label: string
	/** Путь внутри раздела бота. */
	to: string
	/** Короткое пояснение под заголовком страницы. */
	description: string
	adminOnly?: boolean
}

export interface WorkspaceNavSection {
	title: string
	icon: LucideIcon
	items: WorkspaceNavItem[]
}

/** Разделы как в Botmaker: менеджеры находят всё там же, где привыкли. */
export const WORKSPACE_NAV: WorkspaceNavSection[] = [
	{
		title: "Аналитика",
		icon: BarChart3,
		items: [
			{ label: "Сводка", to: "analytics/summary", description: "Общая аналитика по боту" },
			{
				label: "Пользователи",
				to: "analytics/users",
				description: "Все, кто когда-либо заходил в бот",
			},
			{
				label: "Группы",
				to: "analytics/groups",
				description: "На какие группы поделены люди",
			},
			{
				label: "UTM-метки",
				to: "analytics/utm",
				description: "Ссылки t.me/бот?start=метка: откуда пришёл человек",
			},
		],
	},
	{
		title: "Конструктор",
		icon: Wrench,
		items: [
			{
				label: "Главное меню",
				to: "constructor/main-menu",
				description: "Первое, что увидит пользователь, зайдя в бота",
			},
			{
				label: "Воронки",
				to: "constructor/funnels",
				description: "Цепочки сообщений: что бот пишет, спрашивает и когда",
			},
			{
				label: "Группы и каналы",
				to: "constructor/chats",
				description: "Каналы и чаты, с которыми работает бот",
			},
			{
				label: "Ключевые слова",
				to: "constructor/keywords",
				description: "Слова и команды, на которые бот отвечает воронкой",
			},
			{
				label: "Если бот не понял",
				to: "constructor/random-answers",
				description: "Что бот ответит на сообщение, которого не ждал",
			},
			{
				label: "Переменные",
				to: "constructor/variables",
				description: "Что бот запоминает о каждом пользователе",
			},
		],
	},
	{
		title: "Рассылки",
		icon: Megaphone,
		items: [
			{ label: "Рассылки", to: "broadcasts", description: "Сообщения пользователям бота" },
		],
	},
	{
		title: "Настройки бота",
		icon: Settings,
		items: [
			{ label: "Общие", to: "settings/general", description: "Бот, токен и сценарий" },
			{
				label: "Платёжные сервисы",
				to: "settings/payments",
				description: "Оплата в Telegram через ЮKassa",
				adminOnly: true,
			},
		],
	},
]

/** Пункт меню для пути внутри раздела бота: самое длинное совпадение начала пути. */
export function findNavItem(sectionPath: string): WorkspaceNavItem | null {
	let best: WorkspaceNavItem | null = null
	for (const section of WORKSPACE_NAV) {
		for (const item of section.items) {
			if (
				(sectionPath === item.to || sectionPath.startsWith(`${item.to}/`)) &&
				item.to.length > (best?.to.length ?? 0)
			)
				best = item
		}
	}
	return best
}

/** Путь глубже пункта меню: одна рассылка, один пользователь, одна метка. */
export function isInnerSection(sectionPath: string): boolean {
	const item = findNavItem(sectionPath)
	return !!item && sectionPath.replace(/\/$/, "") !== item.to
}
